import { LetterTypes, Sources } from '../generator/types';

import {
  BLOCKS_BY_LETTER_TYPE,
  LetterBlock,
  LetterBlockSet,
  OTAF_HIGHER_BLOCKS,
  OTAF_SAME_BLOCKS,
  ParagraphTemplate,
} from './blocks';
import { PricingMode } from './types';

// Withdrawal has exactly one reason per letter, so its reasons are mutually
// exclusive (unlike decline / OTAF, where blocks combine).
export function isSingleSelectLetterType(
  letterType: LetterTypes | null,
): boolean {
  return letterType === LetterTypes.withdrawal;
}

export function resolveBlockSet(
  letterType: LetterTypes | null,
  pricingMode: PricingMode,
): LetterBlockSet {
  if (!letterType) return {};
  if (letterType === LetterTypes.otaf) {
    return pricingMode === 'same' ? OTAF_SAME_BLOCKS : OTAF_HIGHER_BLOCKS;
  }
  return BLOCKS_BY_LETTER_TYPE[letterType] ?? {};
}

export function resolveParagraphs(
  block: LetterBlock,
  isJuvenile: boolean,
): ParagraphTemplate[] {
  if (isJuvenile && block.juvenileParagraphs) return block.juvenileParagraphs;
  return block.paragraphs;
}

export function resolveParagraphText(
  paragraph: ParagraphTemplate,
  isJuvenile: boolean,
): string {
  if (isJuvenile && paragraph.juvenileText) return paragraph.juvenileText;
  return paragraph.text;
}

export function resolveParagraphContact(
  paragraph: ParagraphTemplate,
  isJuvenile: boolean,
): string | undefined {
  if (isJuvenile && paragraph.juvenileContactAfter) {
    return paragraph.juvenileContactAfter;
  }
  return paragraph.contactAfter;
}

export function getOrderedSources(
  blockSet: LetterBlockSet,
  selectedOrder: Sources[],
): Sources[] {
  return selectedOrder.filter(id => blockSet[id] !== undefined);
}
